import axios from "axios";
import qs from "qs";
import { Toast } from "vant";

const tokenKey = "ZH_Token";

// 测试服务器地址
const devServerURL = "http://api.wish.hebyun.com.cn/api";

// 线上服务器地址
const proServerURL = "http://api.wish.hebyun.com.cn/api";

function isDevelopment() {
  return process && process.env && process.env.NODE_ENV == "development";
}

// 根据环境自动切换服务器地址
const ServerURL = isDevelopment() ? devServerURL : proServerURL;
function getToken() {
  return localStorage.getItem(tokenKey);
}

// 提示
function error(err) {
  return Toast(err);
}

function success(msg) {
  return this.$toast(msg);
}
function setToken(token) {
  localStorage.setItem(tokenKey, token);
}

// 请求处理
const request = axios.create({
  // 远程服务器地址
  baseURL: ServerURL,
  // 超时
  timeout: 60 * 1000,
});

// 请求拦截
request.interceptors.request.use(
  (config) => {
    let uid = localStorage.getItem("uid");

    if (config.method == "get") {
      if (config.url.indexOf("uid=") == -1) {
        config.url =
          config.url +
          ((config.url.indexOf("?") > 0 ? "&" : "?") + "uid=" + uid);
      }
    }
    if (config.method == "post") {
      // debugger;
      let postDatas = config;
      if (typeof postDatas.data == "object") {
        postDatas.data["uid"] = uid;
      } else {
        postDatas["data"] = {
          uid: uid,
        };
      }
      config.data = qs.stringify(postDatas.data);
    }

    return config;
  },
  (err) => {
    // 请求失败
    // hideLoading();
    error("无法连接服务器 : " + err);
    throw err;
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    const { responseType } = response.config;

    // hideLoading();
    // 身份验证失败
    if (response.status == 401) {
      // return window.top.location = "/#/login";
    }
    // 请求
    if (responseType === "blob") {
      if (response.status === 200) {
        return response;
      } else {
        let err = "请求文件出错 : 状态码错误!";
        error(err);
        throw err;
      }
    }

    // 正常的数据请求
    const { code } = response.data;
    // debugger;
    // 服务器端返回错误
    if (code !== "0") {
      let err = response.data.error;
      error(err);
      throw error;
    }

    return response.data;
  },
  (err) => {
    // hideLoading();
    error("无法连接服务器 : " + err);
    throw err;
  }
);

function uploadFile(file, type) {
  if (!file) {
    return;
  }
  const param = new FormData();
  param.append("file", file);
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };

  const url = `/file/uploadFile/${type}`;
  return request.post(url, param, config);
}

function getFile(file) {
  if (!file) {
    return;
  }
  return `${ServerURL}/file/getFile?url=${file}`;
}

export default {
  request,
  isDevelopment,
  getToken,
  setToken,
  uploadFile,
  getFile,
  success,
  error,
};
